<div style="line-height: 45px">
  @if (!this.ccs.isShowIdleEmailSuccess) {
    <form [formGroup]="emailForm" (ngSubmit)="SaveEmail()">
      <div class="email-field-line">
        <div class="email-input">
          <div class="email-input-field">
            <div cbInput label="Email address"
              hideRequiredMarker="true"
              [errorState]="email.invalid && email.touched"
              [class.has-error]="email.invalid && email.touched">
              <input type="email" name="email"
                [ngClass]="{'fs-exclude': true}"
                [formControl]="email"
                required="true"
                appAnalytics="focusout"
                eventCategory="ProductsInCart"
                eventAction="USER_INPUT"
                [eventLabel]="'Business Email Address :' + 'xxxx'" />
              </div>
            </div>
            <button class="email-quote-button background_border_gh">Send</button>
          </div>
          <app-notifications
            [styleType]="'ie-overwrite-style'"
            [showClose]="false"
            [ieNotificationText]="emailIeNotification"
            [iconClass]="'notificationicon'"
          ></app-notifications>
        </div>
      </form>
    } @else {
      <div>
        <div class="email-success-message-container">
          <p class="normal-text">
            <!-- <img src="../../../assets/img/icons/email-Check-icon.svg"> -->
            {{labelDictionary.customizedQuote.emailSentToMessage}}
            <span class="email-underlined">{{email.value}}</span>
          </p>
        </div>
        @if (showOkButton) {
          <div class="btn__container">
            <button (click)="onNoClick()" class="btn__container__close">OK</button>
          </div>
        }
      </div>
    }

  </div>
